var map = {
	"./App": 56176,
	"./App.tsx": 56176,
	"./Cheatcodes": 44282,
	"./Cheatcodes.js": 44282,
	"./Fetch": 81016,
	"./Fetch.tsx": 81016,
	"./api": 32893,
	"./api.ts": 32893,
	"./configureStore": 95095,
	"./configureStore.ts": 95095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57016;